import { isEmpty } from 'lodash-es'
import * as pricingService from '../../services/pricing.service'
import {
  CALCULATE_RATES_FAIL,
  CALCULATE_RATES_SUCCESS,
  CHECK_SHIPPING_RATE_FAIL,
  CHECK_SHIPPING_RATE_SUCCESS,
  FUEL_SURCHARGE_FAIL,
  FUEL_SURCHARGE_SUCCESS,
} from './types'

export const calculateRates = (data) => async (dispatch, getState) => {
  try {
    let userData = {},
      userState = getState().user
    if (userState && userState.profile && !isEmpty(userState.profile)) {
      userData = {
        account_number: userState.profile.account_number,
      }
    }

    const response = await pricingService.calculateRates({
      ...data,
      ...userData,
    })
    if (response.status >= 200 && response.status < 300) {
      const { data } = response
      dispatch({
        type: CALCULATE_RATES_SUCCESS,
      })
      return data
    }
  } catch (error) {
    const errorData = (error.response && error.response.data) || error.message
    dispatch({ type: CALCULATE_RATES_FAIL })
    throw errorData
  }
}

export const checkShippingRate = (data) => async (dispatch, getState) => {
  try {
    let userData = {},
      userState = getState().user
    if (userState && userState.profile && !isEmpty(userState.profile)) {
      userData = {
        account_number: userState.profile.account_number,
      }
    }
    const response = await pricingService.estimatePrice({
      ...data,
      ...userData,
    })
    if (response.status >= 200 && response.status < 300) {
      const { data } = response
      dispatch({
        type: CHECK_SHIPPING_RATE_SUCCESS,
      })
      return data.data
    }
  } catch (error) {
    const errorData = (error.response && error.response.data) || error.message
    dispatch({ type: CHECK_SHIPPING_RATE_FAIL })
    throw errorData
  }
}

export const fuelSurcharge = (data) => async (dispatch) => {
  try {
    const response = await pricingService.groundFuelSurcharge(data)
    // const { data } = response.data
    if (response.status >= 200 && response.status < 300) {
      dispatch({ type: FUEL_SURCHARGE_SUCCESS, surcharges: response.data.data })
    }
  } catch (error) {
    dispatch({ type: FUEL_SURCHARGE_FAIL })
    const message = error.response && error.response.data
    throw message
  }
}
